import { ToppingInfo } from '../topping-info';

import makeClasses from '../../ToppingsByParentId.style';

import type { ToppingToPrint } from 'features/print-management/order-invoice-printing';

export function ToppingItem(props: Props) {
  const { topping, nextLevel, localeLang, previousName } = props;

  const _classes = makeClasses();

  return (
    <ToppingInfo
      topping={topping}
      localeLang={localeLang}
      previousName={previousName}
    >
      {topping.children.length > 0 && (
        <ul data-toppings-level={nextLevel} className={_classes.toppingList}>
          {topping.children.map((childTopping, idx) => (
            <ToppingItem
              key={`${childTopping.id}-${idx}`}
              nextLevel={nextLevel + 1}
              localeLang={localeLang}
              topping={childTopping}
              previousName={topping.children[idx - 1]?.name ?? ''}
            />
          ))}
        </ul>
      )}
    </ToppingInfo>
  );
}

interface Props {
  nextLevel: number;
  localeLang: string;
  topping: ToppingToPrint;
  previousName: ToppingToPrint['name'];
}
